export enum APPMODE {
  DEVELOPMENT = "development",
  PRODUCTION = "production"
}

export enum SideMenuItemKeys {
  DEFAULT_HOME_PAGE = "home",
  USER_MANAGEMENT = "user-management",
  MASTER_MANAGEMENT = "master-management",
  DISPLAY_QUEUE_STATUS = "display-queue-status",
  DISPLAY_SCHEDULE_LIST = "display-schedule-list",
  MANUAL_BOOKING_RETRIEVAL = "manual-booking-retrieval-request",
  EMERGENCY_RETRIEVAL_REQUEST = "emergency-retrieval-request",
  PARKING_OCCUPANCY_MONITORING = "parking-occupancy-monitoring",
  DEAD_PARKING_UPDATE = "dead-parking-update",
  PARKING_PRICE_MANAGEMENT = "parking-price-management",
  PARKING_MANAGEMENT = "parking",
  USER_FEEDBACK = "user-feedback",
  PARKING_HISTORY = "parking-history",
  SUPPORT_QUERY = "support-query",
  MESSAGING = "notification",
  CONCURRENT_REQUEST = "concurrent-request",
  REPORT = "report",
  REPORT_SECTION = "report-section",
  REQUEST_PER_HOUR_REPORT = "request-per-hour-report",
  VISITORS_REPORT = "visitors-report",
  ALL_USERS_PARKING_REPORT = "all-users-report",
  PARKING_DATA_COUNTS_REPORT = "parking-data-count-report",
  IOTHUB_LOGS = "iothub-logs",
  DEVELOPER_OPTIONS = "developer-options",
  ADVANCE_BOOKING_REQUEST = "advance-booking-request",
  ADVANCE_BOOKING_REQUEST_REPORT = "advance-booking-request-report",
  CLIENT_PARKING_AVAILABILITY_LIST = "client-parking-availability-list",
  ABR_PENALTY_COLLECTION_REPORT = "abr-penalty-collection-report",
  LOCATION_STATUS_LIST = "location-status-list"
}

/* enums regarding routing done in the application. */
export const RouteConstants = {
  DEFAULT_HOME_PAGE: "/home",
  ROOT_PAGE: "/",
  PAGE_NOT_FOUND: "/page-not-found",
  COMING_SOON: "/coming-soon",
  ERROR_PAGE: "/error-page400",
  PRIVACY_POLICY: "/privacy-policy",
  CLIENT_PARKING_AVAILABILITY_LIST: "/client-parking-availability-list",

  /* user-management route */
  USER_MANAGEMENT_PAGE: "/user-management",
  USER_LIST_PAGE: "list",
  QUEUE_LIST_PAGE: "list",
  USER_FORM_ADD_PAGE: "create-user-form/add",
  USER_FORM_UPDATE_PAGE: "update-user-form/update",
  USER_FORM_VIEW_PAGE: "view-user-details/view",

  MASTER_MANAGEMENT_PAGE: "/master-management",
  DISPLAY_QUEUE_STATUS_PAGE: "/display-queue-status",
  DISPLAY_SCHEDULE_LIST_PAGE: "/display-schedule-list",
  BOOKING_RETRIEVAL_REQUEST_PAGE: "/manual-booking-retrieval-request",
  EMERGENCY_RETRIEVAL_REQUEST_PAGE: "/emergency-retrieval-request",
  PARKING_OCCUPANCY_MONITORING_PAGE: "/parking-occupancy-monitoring",
  DEAD_PARKING_UPDATE_PAGE: "/dead-parking-update",
  PARKING_PRICE_MANAGEMENT_PAGE: "/parking-price-management",
  USER_FEEDBACK: "/user-feedback",
  PARKING_HISTORY: "/parking-history",
  MESSAGING: "/notification",
  ADD_NOTIFICATION: "/notification/add",
  SUPPORT_QUERY: "/support-query",
  CONCURRENT_REQUEST: "/concurrent-request",
  REQUEST_PER_HOUR_REPORT: "/request-per-hour-report",
  VISITORS_REPORT: "/visitors-report",
  ALL_USERS_PARKING_REPORT: "/all-users-report",
  PARKING_DATA_COUNTS_REPORT: "/parking-data-count-report",
  IOTHUB_LOGS: "/iothub-logs",
  LOCATION_STATUS_LIST: "/location-status-list",
  ADVANCE_BOOKING_REQUEST: "/advance-booking-request",
  ADVANCE_BOOKING_REQUEST_REPORT: "/advance-booking-request-report",
  ABR_PENALTY_COLLECTION_REPORT: "/abr-penalty-collection-report"
};

export enum APIRouteConstants {
  MASTER_MANAGEMENT_ROUTE = "/master",
  MOBILE_USER_ROUTE = "/mobile-user",
  WEB_USER_ROUTE = "/web-user"
}

export enum APIQueryParameter {
  SHOW_DELETED = `?showDeleted={true}`
}

export enum Actions {
  ADD_NOTIFICATION = "add"
}
